import { onUnmounted, watch } from 'vue'

const BODY_LOADING_CLASS = 'loading'

// Kac loader ayni anda aktif. body.loading (reset.css) sayfa scroll'unu kilitler,
// bu yuzden class ancak son loader kapaninca kalkmali.
let activeLoaderCount = 0

const syncBodyClass = () => {
  activeLoaderCount = Math.max(0, activeLoaderCount)
  document.body.classList.toggle(BODY_LOADING_CLASS, activeLoaderCount > 0)
}

/**
 * Tam ekran loader gorunurken body uzerine `loading` class'ini ekler.
 *
 * Gecis karsilastirmasi (false -> true) yerine mutlak degere bakilir: watch
 * `immediate` ile calistiginda oldValue `undefined` gelir ve gecis kurali
 * mount aninda zaten `true` olan bir loader'i hic yakalamaz.
 *
 * @param {import('vue').Ref<boolean>|(() => boolean)} source
 */
export default function useBodyLoadingClass(source) {
  let isCounted = false

  watch(
    source,
    value => {
      if (value && isCounted === false) {
        activeLoaderCount += 1
        isCounted = true
        syncBodyClass()
      } else if (!value && isCounted === true) {
        activeLoaderCount -= 1
        isCounted = false
        syncBodyClass()
      }
    },
    { immediate: true }
  )

  onUnmounted(() => {
    if (isCounted === true) {
      activeLoaderCount -= 1
      isCounted = false
      syncBodyClass()
    }
  })
}

// Vite hot-reload modulu yeniden degerlendirdiginde sayac sifirlanir ama mount
// durumdaki dispatcher'lar hala sayilmis sayilir; sonraki unmount'lari sayaci
// negatife surerdi. Math.max(0, ...) tabani bunu tutuyor, burasi da dev'de
// takili kalmis bir scroll kilidini temizliyor.
if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    activeLoaderCount = 0
    document.body.classList.remove(BODY_LOADING_CLASS)
  })
}
